/**
 * SharePoint Intake status pill — Vanta-style status indicator.
 *
 * Maps connection.status (and missing-connection state) to a colored pill
 * with an explicit label. Same visual language across the wizard and the
 * standalone admin page so users learn the states once.
 */

const PILLS = {
  not_connected:    { label: 'Not connected',  cls: 'bg-slate-700/40 text-slate-300 border-slate-600/50' },
  invited:          { label: 'Awaiting admin', cls: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
                      pulse: true },
  consented:        { label: 'Approved · pick a folder', cls: 'bg-sky-500/15 text-sky-300 border-sky-500/30',
                      pulse: true },
  folder_selected:  { label: 'Connecting',     cls: 'bg-blue-500/15 text-blue-300 border-blue-500/30',
                      pulse: true },
  active:           { label: 'Connected',      cls: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30' },
  paused:           { label: 'Paused',         cls: 'bg-slate-500/20 text-slate-300 border-slate-500/40' },
  error:            { label: 'Needs attention', cls: 'bg-red-500/15 text-red-300 border-red-500/40' },
  revoked:          { label: 'Disconnected',   cls: 'bg-slate-700/40 text-slate-400 border-slate-600/40' },
};

export default function StatusPill({ status }) {
  const p = PILLS[status || 'not_connected'] || PILLS.not_connected;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold border ${p.cls}`}>
      {p.pulse && (
        <span className="relative flex w-1.5 h-1.5">
          <span className="absolute inset-0 rounded-full bg-current opacity-60 animate-ping" />
          <span className="relative inline-flex rounded-full w-1.5 h-1.5 bg-current" />
        </span>
      )}
      {p.label}
    </span>
  );
}
